import { render, staticRenderFns } from "./paymentGoods.vue?vue&type=template&id=80c21872&scoped=true&"
import script from "./paymentGoods.vue?vue&type=script&lang=js&"
export * from "./paymentGoods.vue?vue&type=script&lang=js&"
import style0 from "./paymentGoods.vue?vue&type=style&index=0&id=80c21872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c21872",
  null
  
)

export default component.exports